export function getSum(values: {
  tax_rate: number
  total: number
}[]): {
  subtotal: number
  tax: number
} {
  return values.reduce(
    (acc, item) => {
      return {
        subtotal: acc.subtotal + item.total,
        tax: acc.tax + (item.total * item.tax_rate) / 100
      }
    },
    {
      subtotal: 0,
      tax: 0
    }
  )
}